// extracted by mini-css-extract-plugin
export default {"logo":"app-react-sidebar-Header-module__logo"};